import { vi } from "../../../../date-fns/locale/vi.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    vi
  }
};